import { create } from 'zustand'

export const useFeedbackModalStore = create<{
  showModal: boolean
  toggleModal: (payload: boolean) => void
}>(set => ({
  showModal: false,
  toggleModal: (payload: boolean) => set({ showModal: payload })
}))
